/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useContext, useRef, useState } from "react"
import { Table } from "react-bootstrap"

import * as wjrInput from "@grapecity/wijmo.react.input"
import * as wjcInput from "@grapecity/wijmo.input"

import dayjs from "dayjs"
import OneDayHaisyaTableCard from "./OneDayHaisyaTableCard"
import OneDayHaisyaTableCell from "./OneDayHaisyaTableCell"
import CONSTANT from "../../../../constant"
import {
  ZyomuinListContext,
  SearchConditionContext,
  SelectCellContext,
  CalenderSearchContext,
  MihaisyaSearchContext,
} from "../HaisyaContext"
import {
  THaisyaListGetReq,
  T車輌乗務員,
  T配車,
} from "../../../../service/order/haisya/THaisya"
import { e勤怠区分, T勤怠区分 } from "../../../../constant/enum/unko"
import HaisyaService from "../../../../service/order/haisya/HaisyaService"
import { AppDispatch } from "../../../.."
import { useDispatch } from "react-redux"
import { setAlerts } from "../../../../globalStore/alertStore"
import { sort配送順 } from "../HaisyaRegister"
import CardInfo from "./CardInfo"
import { set配車CardClass, 当日全配車 } from "../haisyaRegisterUtil"
import util from "../../../../ts/util"

const OneDayTab = () => {
  const dispatch: AppDispatch = useDispatch()

  const 配車順List: number[] = []
  for (let index = 1; index <= CONSTANT.一日最大配送数; index++) {
    配車順List.push(index)
  }
  const bodyRef = useRef<HTMLTableSectionElement>(null)
  const { 車輌乗務員List: 乗務員List, set車輌乗務員List: set乗務員List } =
    useContext(ZyomuinListContext)
  const searchCondition = useContext(SearchConditionContext)
  const { selectKey, setSelectData, setSelectKey, setIsModalShow, chip } =
    useContext(SelectCellContext)

  const calenderSearch = useContext(CalenderSearchContext)
  const mihaisyaSearch = useContext(MihaisyaSearchContext)

  const [wjMenu, setWjMenu] = useState<wjcInput.Menu>()
  const [配車wjMenu, set配車WjMenu] = useState<wjcInput.Menu>()

  // TODO: onMenuClickメソッド内にuseContextの更新内容が反映されないためrefに逃がして確認する
  const select乗務員Ref = useRef<T車輌乗務員>()
  const select配車Ref = useRef<T配車>()
  const searchConditionRef = useRef<THaisyaListGetReq>()

  //#region [method]

  // 勤怠用
  const menuInitialized = (menu: wjcInput.Menu) => {
    setWjMenu(menu)
  }

  const onMenuClick = useCallback(
    async (menu: wjcInput.Menu) => {
      if (select乗務員Ref == null || select乗務員Ref.current == null) return
      if (searchConditionRef == null || searchConditionRef.current == null) {
        return
      }
      const 当日配車 = select乗務員Ref.current.受注配車.filter((h) => {
        const isSameDate = dayjs(h.積日).isSame(
          dayjs(searchConditionRef!.current!.積日),
          "date"
        )
        return isSameDate
      })
      if (当日配車.length > 0) {
        alert("既に配車がされているため休暇にできません。")
        return
      }
      const 種別: T勤怠区分 | 0 = menu.selectedValue

      try {
        const service = new HaisyaService()
        const res = await service.kinmubiPost({
          乗務員ID: select乗務員Ref.current.乗務員ID,
          勤務日: searchConditionRef.current.積日,
          勤怠区分: 種別 !== 0 ? 種別 : undefined,
        })
        // 登録成功した場合、一覧の乗務員リストを更新
        if (res.data) {
          const ListRes = await service.getList(searchConditionRef.current)
          set乗務員List([...ListRes.data])
        }
      } catch (error) {
        dispatch(setAlerts(error))
      }
    },
    [searchConditionRef, select乗務員Ref, calenderSearch, mihaisyaSearch]
  )

  // 配車用
  const 配車menuInitialized = (menu: wjcInput.Menu) => {
    set配車WjMenu(menu)
  }

  const on配車MenuClick = useCallback(
    async (menu: wjcInput.Menu) => {
      if (select乗務員Ref == null || select乗務員Ref.current == null) return
      if (select配車Ref == null || select配車Ref.current == null) return
      if (searchConditionRef == null || searchConditionRef.current == null) {
        return
      }
      const 車輌Target = select乗務員Ref.current
      const target = select配車Ref.current

      const 受注No = `${target.受注伝票番号}-${target.受注枝番}`
      if (!window.confirm(`${受注No}の割当を解除します。よろしいですか`)) return
      try {
        const service = new HaisyaService()
        const res = await service.putMihaisya(target.受注配車ID, {
          更新日時: target.更新日時!,
          積日: target.積日!,
          車輌ID: 車輌Target.車輌ID,
        })
        // 登録成功した場合、更新
        if (res.data) {
          calenderSearch(searchConditionRef.current)
          mihaisyaSearch(searchConditionRef.current)
        }
      } catch (error) {
        dispatch(setAlerts(error))
      }
    },
    [searchConditionRef, select乗務員Ref, select配車Ref]
  )

  //#endregion

  return (
    <div className="w-100 h-55rem overflow-scroll">
      <Table className="tumibi-table">
        <thead>
          <tr>
            <th>
              <div>車番</div>
            </th>
            <th>
              <div>担当乗務員名</div>
            </th>
            <th>
              <div>前日最終運行</div>
            </th>
            {配車順List.map((i) => (
              <th key={i}>
                <div>運行{i}</div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody ref={bodyRef}>
          {乗務員List.map((車輌乗務員, rowIndex) => {
            const 当日配車 = 当日全配車(車輌乗務員, searchCondition.積日)
            当日配車.forEach((a, index) => {
              a.配送順 = index + 1
            })

            const 当日積日受注配車 = 当日配車.filter((zh) =>
              dayjs(zh.積日).isSame(dayjs(searchCondition.積日), "date")
            )
            const 別積日受注配車数 = 当日配車.filter(
              (zh) =>
                !dayjs(zh.積日).isSame(dayjs(searchCondition.積日), "date")
            ).length

            const rowKey = `${車輌乗務員.車輌ID}_${車輌乗務員.トレーラ車輌ID}_${車輌乗務員.乗務員ID}_${searchCondition.積日}_${rowIndex}`

            const 欠勤データ = 車輌乗務員.欠勤リスト?.find((欠勤) =>
              dayjs(欠勤.勤務日).isSame(dayjs(searchCondition.積日), "date")
            )

            const 前日 = dayjs(searchCondition.積日).subtract(1, "d")
            const 前日最終データList = 車輌乗務員.受注配車
              .sort(sort配送順)
              .filter((受注配車) => {
                const 卸日 = dayjs(受注配車.卸日)

                return 前日.isSame(卸日, "date")
              })

            const 前日最終データ = 前日最終データList.pop()
            let lastDayClass = "last-day-card rounded"
            let 配送中フラグ = false
            if (前日最終データ != null) {
              let [addClass, inner配送中フラグ] = set配車CardClass(
                車輌乗務員,
                前日最終データ,
                前日.toISOString()
              )
              配送中フラグ = inner配送中フラグ
              lastDayClass = util.addTextWithStartDelimiter(
                lastDayClass,
                addClass
              )
            }
            let cellDefaultClass = ""
            if (欠勤データ != null) {
              switch (欠勤データ.勤怠区分 as T勤怠区分) {
                case e勤怠区分.有給休暇:
                case e勤怠区分.欠勤:
                case e勤怠区分.慶忌休暇:
                case e勤怠区分.特別休暇:
                  cellDefaultClass = "holiday"
                  break
                default:
                  cellDefaultClass = ""
                  break
              }
            }

            return (
              <tr
                key={rowKey}
                className={
                  rowKey === selectKey ||
                  (select乗務員Ref?.current?.乗務員ID === 車輌乗務員.乗務員ID &&
                    select乗務員Ref?.current?.車輌ID === 車輌乗務員.車輌ID)
                    ? "target-row"
                    : ""
                }
                onClick={(_e) => {
                  setSelectKey(rowKey)
                  setSelectData({
                    車輌乗務員,
                    積日: searchCondition.積日,
                    受注配車: 当日配車,
                  })
                }}
                onContextMenu={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  searchConditionRef.current = searchCondition
                  select乗務員Ref.current = 車輌乗務員
                  if (wjMenu == null) return
                  // wjMenu.show(e.nativeEvent)
                }}
                onDoubleClick={(_e) => {
                  setSelectKey(rowKey)
                  setSelectData({
                    車輌乗務員,
                    積日: searchCondition.積日,
                    受注配車: 当日配車,
                  })
                  setIsModalShow(true)
                }}>
                <th className="syaryo-data">
                  <div className="syaban">{車輌乗務員.車番}</div>
                  <div className="fs-6">{車輌乗務員.車種区分名称1}</div>
                  <div>{車輌乗務員.トレーラ車番}</div>
                  <div className="fs-6">{車輌乗務員.トレーラ車種区分名称1}</div>
                </th>
                <th className="zyomuin-data">
                  <div>{車輌乗務員.乗務員名}</div>
                  {当日配車.length > CONSTANT.一日最大配送数 && (
                    <div className="text-danger fs-6">
                      {CONSTANT.一日最大配送数}
                      件以上の運行情報が登録されています。
                    </div>
                  )}
                </th>
                <td className="last-day">
                  <div className="w-100 h-100">
                    {前日最終データ && (
                      <div className={lastDayClass}>
                        <CardInfo
                          車輌乗務員={車輌乗務員}
                          haisoTyuFlg={配送中フラグ}
                          cardInfo={前日最終データ}
                          chip={chip}></CardInfo>
                      </div>
                    )}
                  </div>
                </td>
                {配車順List.map((i) => {
                  let 配車 = 当日配車.find((h) => {
                    return h.配送順 === i
                  })

                  let 配送順 = i
                  // 当日積日の配車のみ配送順は移動できる
                  if (
                    当日積日受注配車.find(
                      (tzh) => tzh.受注配車ID === 配車?.受注配車ID
                    )
                  ) {
                    配送順 -= 別積日受注配車数
                  }

                  const key = `${rowKey}_${i}`
                  return (
                    <OneDayHaisyaTableCell
                      className={cellDefaultClass}
                      zyomuin={車輌乗務員}
                      tumibi={searchCondition.積日}
                      haisoNo={配送順}
                      key={key}>
                      {配車 != null && (
                        <OneDayHaisyaTableCard
                          onContextMenuHandler={(e) => {
                            e.preventDefault()
                            e.stopPropagation()

                            // TODO:一旦過去日もいじれるようにする
                            // 過去日付はそもそもメニューがでないようにする
                            // const セル積日 = dayjs(searchCondition.積日)
                            // if (
                            //   !セル積日.isSame(dayjs(営業日), "d") &&
                            //   セル積日.isBefore(dayjs(営業日), "d")
                            // ) {
                            //   return
                            // }

                            searchConditionRef.current = searchCondition
                            select乗務員Ref.current = 車輌乗務員
                            select配車Ref.current = 配車
                            if (配車wjMenu == null) return
                            配車wjMenu.show(e.nativeEvent)
                          }}
                          date={searchCondition.積日}
                          chip={chip}
                          zyomuin={車輌乗務員}
                          haisyaInfo={配車}></OneDayHaisyaTableCard>
                      )}
                    </OneDayHaisyaTableCell>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </Table>
      <wjrInput.Menu
        initialized={menuInitialized}
        selectedValuePath="cmd"
        style={{ display: "none" }}
        isDroppedDownChanged={(dropDown: wjcInput.DropDown) => {
          if (dropDown.isDroppedDown) {
          } else {
            select乗務員Ref.current = undefined
          }
        }}
        itemClicked={(e: wjcInput.Menu) => {
          onMenuClick(e)
        }}
        header="Context Menu">
        <wjrInput.MenuItem cmd={e勤怠区分.有給休暇}>有給</wjrInput.MenuItem>
        <wjrInput.MenuItem cmd={e勤怠区分.特別休暇}>特休</wjrInput.MenuItem>
        <wjrInput.MenuItem cmd={e勤怠区分.欠勤}>欠勤</wjrInput.MenuItem>
        <wjrInput.MenuItem cmd={undefined}>休暇取消</wjrInput.MenuItem>
        <wjrInput.MenuSeparator></wjrInput.MenuSeparator>
      </wjrInput.Menu>
      <wjrInput.Menu
        initialized={配車menuInitialized}
        style={{ display: "none" }}
        isDroppedDownChanged={(dropDown: wjcInput.DropDown) => {
          if (dropDown.isDroppedDown) {
          } else {
            select乗務員Ref.current = undefined
            select配車Ref.current = undefined
          }
        }}
        itemClicked={(e: wjcInput.Menu) => {
          on配車MenuClick(e)
        }}
        header="Context Menu">
        <wjrInput.MenuItem>
          <div className="text-danger">配車解除</div>
        </wjrInput.MenuItem>
      </wjrInput.Menu>
    </div>
  )
}

export default OneDayTab
